<div class="card-user">
  <img [src]="avatarUrl">

  <div class="card-details">
    <div class="card-details-header">
      <span class="card-user-name">{{ name }}</span>
      <span *ngIf="time" class="card-date"> | {{ time }}</span>
      <span *ngFor="let text of headerPostText" class="card-date"> | <span [ngClass]="headerPostTextClass">{{ text | translate }}</span></span>
    </div>
    <div class="text" *ngIf="type === 'text'" [innerHTML]="displayText | markdown | async"></div>
    <button *ngIf="type === 'text' && canShowOriginal" (click)="toggleOriginal()"
            class="show-original-toggle" type="button">
      {{ (showingOriginal ? 'SHARED.Show_translation' : 'SHARED.Show_original') | translate }}
    </button>

    <!-- `text`, not `displayText`: an audio note's value is an object URI. -->
    <audio *ngIf="type ==='audio'" class="note-audio" controls="" preload="metadata">
      <source [src]="text" type="audio/mp4">
    </audio>
  </div>
</div>
